import FeaturedProjects from 'components/shared/FeaturedProjects/FeaturedProjects'
import PageSection from 'components/shared/PageSection/PageSection'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './FeaturedSection.scss'

export const FeaturedSection = ({ featured, locale, t, gtm = {} }) => (
  <div id="projects">
    <PageSection
      className="homepage-featured"
      title={t('homepage.featured.title')}
      description={t('homepage.featured.description')}
    >
      <FeaturedProjects featured={featured} locale={locale} gtm={gtm} />
    </PageSection>
  </div>
)

FeaturedSection.propTypes = {
  featured: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  gtm: PropTypes.object,
}

export default withTranslation('translations')(FeaturedSection)
